import {
  AvatarEmpty,
  Chip,
  DottedText,
  HighPriority,
  LowPriority,
  MediumPriority,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import ticketManagementConstants from '../messages/TicketManagementConstants';
import {
  Avatar,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import { UserAccessConstants } from './userAccess';
import logo from '../../../public/Images/logo.png';

//Funtion to Generate hash from a unique attribute to have unique avatar color for each user
export const getAvatarColor = (str: string) => {
  const avatarColors = ticketManagementConstants.avatarColors;
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    hash = str?.charCodeAt(i) + ((hash << 5) - hash);
  }
  return avatarColors[Math.abs(hash) % avatarColors?.length];
};

export const formatTicketData = (
  data: any,
  role: string,
  setSelectedTicketId: any,
  setDetailsWindowOpen: any,
) => {
  const formattedData = data.map((item: any) => {
    const isOverDue: boolean = moment(item?.dueDate).isBefore(moment(), 'day');
    return [
      item?.ticketId ?? '-',
      <div
        onClick={() => {
          setSelectedTicketId(item?.ticketId);
          setDetailsWindowOpen(true);
        }}
      >
        <DottedText text={item?.ticketId.slice(-6) ?? '-'} />
      </div>,
      item?.topic ? (
        <div style={{ display: 'flex', gap: '7px' }}>
          <Tooltip title={item?.topic}>
            <div
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                width: '200px',
                whiteSpace: 'nowrap',
              }}
            >
              {item.topic}
            </div>
          </Tooltip>
          {isOverDue && getChipComponent('overDue')}
        </div>
      ) : (
        '-'
      ),
      item?.platform ?? '-',
      item?.type ?? '-',
      getChipComponent(item?.status),
      item?.dueDate ? (
        isOverDue ? (
          <Typography
            textColor={'#D6545E'}
            fontType="regular"
            fontSize="14px"
            lineHeight="24px"
          >
            {moment(item?.dueDate)
              .utc()
              .format(ticketManagementConstants.DETAILS_MODAL.dueDateFormat)}
          </Typography>
        ) : (
          moment(item?.dueDate)
            .utc()
            .format(ticketManagementConstants.DETAILS_MODAL.dueDateFormat)
        )
      ) : (
        '-'
      ),
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        {getPriorityIcon(
          item?.priority,
          role === UserAccessConstants.SUPER_ADMIN ? false : true,
        )}
        {role === UserAccessConstants.SUPER_ADMIN &&
          (item?.assigneeId ? (
            getAvatarIcon(item?.assigneeId?.email, item.assigneeId.firstName)
          ) : (
            <AvatarEmpty />
          ))}
      </div>,
    ];
  });
  return formattedData;
};

export const getChipComponent = (
  chipType: 'to_do' | 'in_progress' | 'in_review' | 'completed' | 'overDue',
) => {
  switch (chipType) {
    case 'to_do':
      return (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.AIQChips?.textColor3}
            >
              {'To Do'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.AIQChips?.background3}
          border={patientAccessTheme.palette.AIQChips?.border1}
          borderRadius="4px"
          padding="5px 8px"
          height="25px"
          width={'110px'}
        />
      );
    case 'in_progress':
      return (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.primary[500]}
            >
              {'In Progress'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.AIQChips?.background15}
          border={'0.3px solid' + patientAccessTheme.palette.primary[500]}
          borderRadius="4px"
          padding="5px 8px"
          height="25px"
          width={'110px'}
        />
      );

    case 'in_review':
      return (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.primary[500]}
            >
              {'In Review'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.AIQChips?.background15}
          border={'0.3px solid' + patientAccessTheme.palette.primary[500]}
          borderRadius="4px"
          padding="5px 8px"
          height="25px"
          width={'110px'}
        />
      );

    case 'completed':
      return (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.AIQChips?.textColor2}
            >
              {'Completed'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.AIQChips?.background2}
          border={'0.3px solid rgba(0, 130, 114, 0.5)'}
          borderRadius="4px"
          padding="5px 8px"
          height="25px"
          width={'110px'}
        />
      );

    case 'overDue':
      return (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.AIQChips?.textColor1}
            >
              {'Overdue'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.AIQChips?.background1}
          border="0.3px solid rgba(226, 84, 84, 0.5)"
          borderRadius="4px"
          padding="5px 8px"
          height="25px"
          width={'90px'}
        />
      );
    default:
      return (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.grey[900]}
            >
              {'na'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.grey[300]}
          border={'0.3px solid' + patientAccessTheme.palette.grey[900]}
          borderRadius="4px"
          padding="5px 8px"
          height="25px"
          width={'110px'}
        />
      );
  }
};

export const getPriorityIcon = (
  priotity: 'low' | 'medium' | 'high',
  isFullForm?: boolean,
) => {
  let icon: any = <></>;
  let value: string = '';
  switch (priotity) {
    case 'low':
      icon = <LowPriority />;
      value = 'Low';
      break;
    case 'medium':
      icon = <MediumPriority />;
      value = 'Medium';
      break;
    case 'high':
      icon = <HighPriority />;
      value = 'High';
      break;
    default:
      icon = <LowPriority />;
      break;
  }
  return isFullForm ? (
    <div
      style={{
        display: 'flex',
        gap: '3px',
        alignItems: 'center',
      }}
    >
      {icon}
      {value}
    </div>
  ) : (
    icon
  );
};

export const getAvatarIcon = (
  email: string,
  firstName?: string,
  hideUser?: boolean,
) => {
  return (
    <Avatar
      alt={''}
      width="24px"
      height="24px"
      backgroundColor={
        hideUser
          ? patientAccessTheme.palette.primary.white
          : getAvatarColor(email)
      }
      avatarText={
        hideUser ? (
          <img height="22px" src={logo} />
        ) : (
          <Typography
            textColor={patientAccessTheme.palette.avatar?.avatarColor}
            fontType="medium"
            fontSize="16px"
            lineHeight="24px"
          >
            {firstName
              ? firstName?.charAt(0).toUpperCase()
              : email?.charAt(0).toUpperCase()}
          </Typography>
        )
      }
    />
  );
};

export const getAvatarComponent = (
  email: string,
  firstName: string,
  lastName: string,
) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
      }}
    >
      {getAvatarIcon(email, firstName)}
      {firstName} {lastName}
    </div>
  );
};

export const formatFileSize = (sizeInBytes: number) => {
  if (sizeInBytes >= 1024 * 1024) {
    // Convert to MB
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  } else if (sizeInBytes >= 1024) {
    // Convert to KB
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  } else {
    // Show in Bytes if less than 1 KB
    return `${sizeInBytes} Bytes`;
  }
};
